import { useCallback, useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export default function useInfiniteOrders() {
  const { data, loading, fetchMore } = useQuery(AdminAPI.order.LIST_REQUESTS, {
    fetchPolicy: 'network-only'
  })

  const loadNext = useCallback(() => {
    fetchMore({
      variables: {
        cursor: data?.listRequestOrders.cursor
      },
      updateQuery(previousData, { fetchMoreResult }) {
        return {
          listRequestOrders: {
            items: [
              ...previousData.listRequestOrders.items,
              ...fetchMoreResult.listRequestOrders.items
            ],
            cursor: fetchMoreResult.listRequestOrders.cursor
          }
        }
      }
    })
  }, [data, fetchMore])

  const orders = useMemo(() => {
    return data?.listRequestOrders.items.map(o =>
      getFragment(SharedAPI.order.ORDER_FRAGMENT, o)
    )
  }, [data])

  return {
    orders,
    loadNext,
    loading,
    hasMore: !!data?.listRequestOrders.cursor
  }
}
